import { Component } from '@angular/core';
import { NavController,NavParams } from 'ionic-angular';

import { Utils } from '../../../providers/service/utils';
import { WebService } from '../../../providers/service/webservice';
import { SAVEORUPDATE } from '../../../providers/config/serviceurl';
import { StorageService } from '../../../providers/service/storageservice';
import { AppState } from '../../../app/app.global';

@Component({
  selector: 'page-addCalendar',
  templateUrl: 'addcalendar.html'
})
export class AddCalendarPage {
	
	navTitle :string;
	privateCalendars:any[];
	currentUser:any;
	selColors=[
		{name:"默认颜色",value:"#488aff"},
		{name:"番茄红",value:"#dd0000"},
		{name:"橘红色",value:"#f1501c"},
		{name:"香蕉黄",value:"#f4bd22"},
		{name:"罗勒绿",value:"#087e41"},
		{name:"鼠尾草绿",value:"#31b77a"},
		{name:"蓝莓色",value:"#3f53ac"},
		{name:"薰衣草色",value:"#7983cb"},
		{name:"葡萄紫",value:"#8e2ba9"}
	];
	calendar ={
		 id:'',
		 name:'',
		 color:'#488aff',
		 isShow:false,
		 isRemind:false,
		 type:''
	};
	
  constructor(public navCtrl: NavController,public params: NavParams,private webService:WebService,public global: AppState) {
  		if(params.data.calendar){
  			this.calendar = params.data.calendar;
  		}
			this.navTitle =  params.data.navTitle;
			this.calendar.type = params.data.navType;
			this.privateCalendars =  params.data.privateCalendars;
  }
	  
	saveOrUpdateClendar(){
		this.currentUser = StorageService.getObj("currentUser");
		var params = {'userId':this.currentUser.userId,
									'id':this.calendar.id,
									'name':Utils.base64Encode(this.calendar.name),
									'color':this.calendar.color,
									'isShow':Utils.formatOneOrZreo(this.calendar.isShow),
									'isRemind':Utils.formatOneOrZreo(this.calendar.isRemind),
									'type':this.calendar.type,
		};
		if(this.calendar.id){//修改
			this.webService.post(SAVEORUPDATE,params,"新增更新");
		}else{//新增
			this.webService.post(SAVEORUPDATE,params,"新增更新").then(anyObj =>this.setCId(anyObj));
			this.privateCalendars.push(this.calendar);
		}
		this.navCtrl.pop();
	}
	
	//处理数据
  setCId(obj :any){
		if(obj){
			this.calendar.id=obj.newId;
		}
	}

}



// WEBPACK FOOTER //
// ./src/pages/trip/addcalendar/addcalendar.ts